<script setup>
// Shared loading state for anything that fetches a site's content before it
// can render (SiteView.vue's /site/:id, PreviewSiteView.vue's
// /preview/:token) — a plain-text "Loading site..." reads as broken rather
// than intentional. Uses the app's own brand accent (see main.js's Vuetify
// theme), not the tenant's --color-primary — that variable lives inside the
// site's own content, which hasn't loaded yet at this point.
</script>

<template>
  <div class="site-loading">
    <div class="spinner" aria-hidden="true" />
    <p>Loading…</p>
  </div>
</template>

<style scoped>
.site-loading {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 32px;
  background: var(--surface-alt);
  color: var(--text-primary);
  font: 600 1rem/1.4 system-ui, sans-serif;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(242, 110, 46, 0.2);
  border-top-color: #f26e2e;
  border-radius: 50%;
  animation: site-loading-spin 0.8s linear infinite;
}

@keyframes site-loading-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
